import React from 'react'
import { CopyButton } from '@dawnlabs/tacklebox'
import { Box, Text, Link, HR, Row, Column, Button } from './styled'
import Header from './Header'
import EmailSubscribe from './EmailSubscribe'
import styled from 'styled-components'

const Spacer = styled.div`
  margin-bottom: 5rem;
`

export const ContactSection = props => (
  <Column
    alignItems="center"
    justifyContent="center"
    maxWidth="85rem"
    mx="auto"
    my={9}
  >
    <Text.p width="100%" textAlign="center" mb={5}>
      {props.prompt}
    </Text.p>
    {props.children}
  </Column>
)

const Footer = props => (
  <Column is="footer" color="black" bg="gray0" width="100%" alignItems="center">
    {/* {props.hasContactSection !== false ? (
      <React.Fragment>
        <ContactSection prompt="Want to get in touch?">
          <Link.internal
            color="black"
            onClick={props.openContactModal}
            fontSize={6}
            fontWeight="medium"
          >
            CONTACT US
          </Link.internal>
        </ContactSection>
        <Box maxWidth="85rem" width="100%">
          <HR px={['1.5rem', '5rem']} />
        </Box>
      </React.Fragment>
    ) : (
      <Spacer />
    )} */}
    <Spacer />
    <Row
      flexDirection={['column-reverse', 'row']}
      maxWidth="85rem"
      px={['1.5rem', '5rem']}
      mx="auto"
      mb={8}
      width="100%"
      justifyContent="space-between"
    >
      <Column mb={0}>
        <Header mt={-4} mb={5}>
          dawn
        </Header>
        <Box display="inline" position="relative">
          <CopyButton text="hi@dawnlabs.io">
            {({ onClick, copied }) => (
              <Button
                onClick={onClick}
                fontSize={2}
                fontWeight={400}
                bg="transparent"
                border="none"
                px={0}
                py={0}
                mb={3}
              >
                {copied && (
                  <Box right={-52} color="green" position="absolute">
                    Copied!
                  </Box>
                )}
                <u>hi@dawnlabs.io</u>
              </Button>
            )}
          </CopyButton>
        </Box>
        <Link fontSize={2} href="tel:1-262-372-2182" underline="true">
          +1 (262) 372-2182
        </Link>
      </Column>
      <Column mb={[7, 0]} maxWidth={[200, 'unset']}>
        <Text mb={2} fontSize={2}>
          Newsletter
        </Text>
        <EmailSubscribe />
      </Column>
      <Column mb={[6, 0]} flexDirection={['row', 'column']}>
        <Link mr={[5, 0]} mb={3} to="/work">
          Work
        </Link>
        <Link mr={[5, 0]} mb={3} to="/about">
          About
        </Link>
        <Link mr={[5, 0]} mb={3} to="/jobs">
          Jobs
        </Link>
        <Link mr={[5, 0]} mb={3} to="/open-source">
          Open Source
        </Link>
      </Column>
      <Column mb={[5, 0]} mr={3} flexDirection={['row', 'column']}>
        <Link mr={[5, 0]} mb={3} href="https://twitter.com/dawn_labs">
          Twitter
        </Link>
        <Link mb={3} href="https://github.com/dawnlabs">
          GitHub
        </Link>
      </Column>
    </Row>
  </Column>
)

export default Footer
